module.exports = __webpack_public_path__ + "static/media/Phoenix.0fd2709d.png";